import { useEffect, useRef } from 'react';
import useCounterStore from '@/store';
import AuthService from '@/services/auth';
import { modelService } from '@/services/modelService';

/**
 * 全局模型初始化Hook
 * 负责在应用启动时查询可用模型列表，并设置默认模型
 */
export const useGlobalModelInit = () => {
    const { modal, setModal } = useCounterStore();
    const initRequested = useRef(false);

    useEffect(() => {
        // 确保初始化只执行一次
        if (initRequested.current) return;
        initRequested.current = true;

        const initializeModels = async () => {
            try {
                // 检查是否已登录
                const isAuthenticated = AuthService.isAuthenticated();
                if (!isAuthenticated) {
                    console.log('用户未登录，跳过模型初始化');
                    return;
                }

                console.log('开始初始化模型列表...');
                
                // 使用模型服务获取模型列表（带缓存）
                const modelList = await modelService.getModelList();
                
                if (!modelList || modelList.length === 0) {
                    console.warn('未获取到可用模型列表');
                    return;
                }

                console.log('获取到模型列表:', modelList);

                // 检查当前选择的模型是否存在于模型列表中
                const currentModel = modal;
                const modelExists = modelList.some(model => model.code === currentModel);

                if (!currentModel || !modelExists) {
                    // 如果没有选择模型或当前模型不存在，选择第一个可用模型
                    const firstModel = modelList[0];
                    console.log(`设置默认模型: ${firstModel.name} (${firstModel.code})`);
                    setModal(firstModel.code);
                } else {
                    console.log(`当前模型有效: ${currentModel}`);
                }

            } catch (error) {
                console.error('模型初始化失败:', error);
                // 如果API调用失败，保持当前模型设置不变
            }
        };

        // 延迟执行，确保其他初始化完成
        const timer = setTimeout(initializeModels, 100);
        
        return () => clearTimeout(timer);
    }, [modal, setModal]);
};

export default useGlobalModelInit;